import UserSevice from '@/service/user'
import OrganizationSevice from '@/service/organization'
export default {
  getData ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.getUser(payload.page, payload.per_page, payload.search, payload.sort, payload.status, payload.organization_id, payload.group_id).then(res => {
        if (res.status === 200) {
          commit('setData', res.data)
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getOrganization ({ commit }, payload) {
    OrganizationSevice.getOrganization().then(res => {
      if (res.status === 200) {
        commit('setOrganization', res)
        // window.scroll(0, 0)
      }
    })
  },

  createUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.createUser(payload.user).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  showUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.showUser(payload.user).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.updateUser(payload.user).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  destroyUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.destroyUser(payload.user).then(res => {
        commit('destroyUser', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getTrashUser ({ commit }, payload) {
    UserSevice.getTrashUser(payload.page, payload.per_page).then(res => {
      if (res.status === 200) {
        commit('getTrashUser', res.data)
        // window.scroll(0, 0)
      }
    })
  },

  restore ({ commit }, payload) {
    UserSevice.restore(payload.data).then(res => {
      if (res.status === 200) {
        commit('restore', res.data.data)
        // window.scroll(0, 0)
      }
    })
  },

  activeUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.activeUser(payload.user).then(res => {
        if (res.status === 200) {
          commit('updateUser', res.data.data)
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  deactivateUser ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.deactivateUser(payload.user).then(res => {
        if (res.status === 200) {
          commit('updateUser', res.data.data)
          resolve(res.data.data)
        }
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  getUserOnline ({commit}, payload) {
    return new Promise((resolve, reject) => {
      UserSevice.getUserOnline().then(res => {
        commit('getUserOnline', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user/actions.js